import { render, staticRenderFns } from "./seeorder.vue?vue&type=template&id=2b3e37ce&scoped=true&"
import script from "./seeorder.vue?vue&type=script&lang=js&"
export * from "./seeorder.vue?vue&type=script&lang=js&"
import style0 from "./seeorder.vue?vue&type=style&index=0&id=2b3e37ce&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b3e37ce",
  null
  
)

export default component.exports